export enum AppConfigKeys {
  STORE_FRONT_ID_KEY = 'storefrontId',

  GEO_SERVICE_KEY = 'geoServiceURL',
  GEO_SERVICE_SERVER_KEY = 'geoServiceServerURL',
  STOREFRONT_SERVICE_KEY = 'storefrontURL',
  CATALOG_SERVICE_KEY = 'catalogURL',
  UMS_SERVICE_KEY = 'UmsURL',
  SUBSCRIPTION_SERVICE_KEY = 'subscriptionURL',
  CREDITS_SERVICE_KEY = 'creditsURL',
  IMAGE_RESIZE_SERVICE_KEY = 'imageResizeURL',
  VOD_METADATA_SERVICE_KEY = 'vodMetaDataURL',
  PERSONALIZATION_SERVICE_KEY = 'personalizationURL',
  OAUTH_SERVICE_KEY = 'oAuthURL',
  CLIENT_REGISTRATION_SERVICE_KEY = 'clientRegURL',
  CONTENT_AUTH_SERVICE_KEY = 'contentAuthURL',
  BOOKMARK_SERVICE_KEY = 'bookmarkURL',
  FAVORITE_SERVICE_KEY = 'favoriteURL',
  SEARCH_HISTORY_SERVICE_KEY = 'searchHistoryURL',
  WIDEVINE_CERTIFICATE_SERVICE_KEY = 'widevineCertBinUrl',
  HEARTBEAT_SERVICE_SERVICE_KEY = 'heartBeatURL',
  LOCALIZATION_SERVICE_KEY = 'localizationURL',
  CHECK_REDEEM_SERVICE_KEY = 'checkRedeemURL',

  HELP_CENTER_URL_KEY = 'helpCenterURL',
  TERMS_AND_CONDITIONS_URL_KEY = 'termsAndConditionsURL',
  PRIVACY_POLICY_URL_KEY = 'privacyPolicyURL',

  WALLET_CREDITS_SYNC_INTERVAL_KEY = 'walletCreditsSyncInterval',
  HEARTBEAT_SYNC_INTERVAL_KEY = 'heartBeatSyncInterval',
  NEW_RELIC_SYNC_INTERVAL_KEY = 'newRelicSyncInterval',

  MIN_MAX_USER_NAME_KEY = 'minMaxUsername',
  MIN_MAX_PWD_KEY = 'minMaxPwd',

  PREVIEW_MODE_AUTO_POP_INTERVAL_KEY = 'previewAutoPopIntervalMs',

  ALLOWED_REGIONS = 'allowedRegions',
  GEO_SERVICE_TOKEN = 'geoServiceToken',

  UMS_API_USER_KEY = 'umsApiUser',
  UMS_API_TOKEN_KEY = 'umsApiToken',
  CHANNEL_PARTNER_ID_KEY = 'channelPartnerID',

  FL_CLIENT_ID = 'clientID',
  FL_CLIENT_SECRET = 'clientSecret',
  FL_X_CLIENT_ID = 'xClientId',

  MARKETING_CAROUSEL_KEY = 'marketingCarousel',
  MARKETING_DICTIONARY = 'marketingDictionary',
  PREVIEW_IMAGE_URL_KEY = 'previewImageUrl',
  SUBSCRIPTION_CONFIRM_KEY = 'subscriptionConfirmationImageUrl',
  CONTINUE_SUBSCRIPTION_IMAGE_URL_KEY = 'continueSubscriptionImageUrl',

  CREDITS_REFRESH_INTERVAL_KEY = 'creditsRefreshIntervalMs',

  ONBOARDING_RESOURCE_KEY = 'onboardingResource',

  MORE_SERVICE_FILTER_TEMPLATE_KEY = 'moreFromServiceFilterTemplate',
  RECOMMENDED_FILTER_TEMPLATE_KEY = 'recommendedGenreFilterTemplate',

  RECOMMENDED_SEARCH_STOREFRONT_ID = 'recommendSearchStorefrontId',
  RECOMMENDED_SEARCH_STOREFRONT_TAB_ID = 'recommendSearchStorefrontTabId',
  RECOMMENDATION_URL = 'recommendURL',
  LINK_DEVICE_URL = 'linkDeviceURL',
  GEO_SERVICE_URL = 'geoLocationURL',

  BOOKMARK_SYNC_INTERVAL_MS = 'bookmarkSyncIntervalMs',
  BOOKMARK_DELETE_THRESHOLD = 'bookmarkDeleteThreshold',

  STREAM_CONCURRENCY_SERVICE_KEY = 'strConcurrencyURL',
  STREAM_CONCURRENCY_SYNC_INTERVAL_MS = 'streamConcurrencySyncIntervalMs',
  ENABLE_PLAY_READY = 'enablePlayReady',
  PLAYBACK_INPROGRESS = 'playbackReportingIntervalMs',

  EVERGENT_SALT_KEY = 'iframe-salt',
  EVERGENT_IFRAME_URL = 'evJustPayIframeURL',

  HISTORY_KEY = 'historyURL',
  MY_USAGE = 'usageURL',

  ENABLE_NEW_RELIC = 'enableNewrelic',
  NEWRELIC_ACCOUNTID = 'accountID',
  NEWRELIC_TRUSTKEY = 'trustKey',
  NEWRELIC_AGENTID = 'agentID',
  NEWRELIC_LICENSEKEY = 'licenseKey',
  NEWRELIC_APPID = 'applicationID',

  ENABLE_CLEVERTAP = 'enableClevertap',

  MARKETING_STOREFRONT_ID = 'marketingStorefrontId',
  MY_CONTENT_EXPIRING_SOON_DAYS_THRESHOLD = 'mycontent.expiringSoonThresholdDays',
  OVAT_URL = 'ovatURL',
  RECOMMENDATION_SERVICE_KEY = 'recommendationServiceURL',
  UP_NEXT_PERCENTAGE_THRESHOLD = 'upNextPercentageThreshold',
  BASIC_AUTHORIZATION = 'basicAuthorization',
  PROFILE_URL = 'profileUrl',
  CONTACTUS_IFRAME = 'contactUsIframe',
  KUSTOMER_ENABLE = 'kustomerEnable',
  NEWRELIC_ENABLE = 'newrelicEnable',
  YOUBORA_ENABLE = 'youboraEnabled',
  PROMOTIONAL_ENABLED = 'promotionalEnabled',
  PROMOTIONAL_CONTENT = 'promotionalContainer',
  STOREFRONT_CONTENT_LIMIT = 'storefrontContentLimit',
  RECOMMENDATION_SERVICE_URL = 'recommendationServiceURL',
  NEW_RECOMMENDATION_SERVICE_URL = 'recommendationURL',
  DISPLAY_LANGUAGE = 'displayLanguage',
  CATALOGUE_LANGUAGE = 'catalogueLanguage',
  NO_SEARCH_RESULTS_URL = 'noSearchResultsURL',
  GUEST_FLAT_URL = 'guestFlatURL',
  GTM_URL = 'gtmURL',
  GTM_TRACKING_ID = 'gtmTrackingID',
  GTM_AUTH = 'gtmAuth',
  GTM_PREVIEW = 'gtmPreview',

  COMBO_PACK_KEY = 'comboPackKey',

  EV_GLOBAL_BU = 'evGlobalBU',
  EV_CHANNEL_LIST = 'evBUChannelList',

  ERROR_CODE_TRANSLATION = 'errorCodeTranslation',
  ENABLE_UPGRADE = 'enableUpgrade',

  // Player Configurations:
  MIN_BUFFER = 'minBuffer', // 2,
  MAX_BUFFER = 'maxBuffer', // 2,
  BUFFER_BEHIND = 'bufferBehind', // 3
  NETWORK_RETRIES = 'networkRetries', // - 2
  NETWORK_TIMEOUT = 'networkTimeout', // - 30
  STALL_TIMEOUT = 'stallTimeout', // - 5
  CONNECTION_TIMOUT = 'connectionTimeout', // - 10
  RETRY_DELAY = 'retryDelay', // - 1
  PREFERRED_BITRATE = 'preferredBitrate',
  INACCURATE_MANIFEST_TOLERANCE = 'inaccurateManifestTolerance',
  IGNORE_MIN_BUFFER_TIME = 'ignoreMinBufferTime',
  USE_NETWORK_INFORMATION = 'useNetworkInformation',
  MINTOTALBYTES = 'minTotalBytes',
  MINBYTES = 'minBytes',
  FASTHALFLIFE = 'fastHalfLife',
  SLOWHALFLIFE = 'slowHalfLife',
  BANDWIDTHUPGRADETARGET = 'bandwidthUpgradeTarget',
  BANDWIDTHDOWNGRADETARGET = 'bandwidthDowngradeTarget',
  SWITCHINTERVAL = 'switchInterval',

  LIVE_MIN_BUFFER = 'liveMinBuffer', // 2,
  LIVE_MAX_BUFFER = 'liveMaxBuffer', // 2,
  LIVE_BUFFER_BEHIND = 'liveBufferBehind', // 3
  LIVE_NETWORK_RETRIES = 'liveNetworkRetries', // - 2
  LIVE_NETWORK_TIMEOUT = 'liveNetworkTimeout', // - 30
  LIVE_STALL_TIMEOUT = 'liveStallTimeout', // - 5
  LIVE_CONNECTION_TIMOUT = 'liveConnectionTimeout', // - 10
  LIVE_RETRY_DELAY = 'liveRetryDelay', // - 1
  LIVE_PREFERRED_BITRATE = 'livePreferredBitrate',
  LIVE_INACCURATE_MANIFEST_TOLERANCE = 'liveInaccurateManifestTolerance',
  LIVE_IGNORE_MIN_BUFFER_TIME = 'liveIgnoreMinBufferTime',
  LIVE_USE_NETWORK_INFORMATION = 'liveUseNetworkInformation',
  LIVE_IGNORESUGGESTEDPRESENTATIONDELAY = 'liveIgnoreSuggestedPresentationDelay',
  LIVE_DEFAULTPRESENTATIONDELAY = 'liveDefaultPresentationDelay',
  LIVE_MINTOTALBYTES = 'liveMinTotalBytes',
  LIVE_MINBYTES = 'liveMinBytes',
  LIVE_FASTHALFLIFE = 'liveFastHalfLife',
  LIVE_SLOWHALFLIFE = 'liveSlowHalfLife',
  LIVE_BANDWIDTHUPGRADETARGET = 'liveBandwidthUpgradeTarget',
  LIVE_BANDWIDTHDOWNGRADETARGET = 'liveBandwidthDowngradeTarget',
  LIVE_SWITCHINTERVAL = 'liveSwitchInterval',

  ENABLE_THUMBNAIL = 'enableThumbnail',
  STEP_PREDEFINED_MOVIE = 'stepPredefinedMovie', // 120
  STEP_PREDEFINED_TRAILER = 'stepPredefinedTrailer', //10
  STEP_PREDEFINED_SHOW = 'stepPredefinedShow', //10
  STEP_PREDEFINED_MOVIE_LG = 'stepPredefinedMovieLG', // 10
  STEP_PREDEFINED_TRAILER_LG = 'stepPredefinedTrailerLG', //10
  STEP_PREDEFINED_SHOW_LG = 'stepPredefinedShowLG', //10
  CONTAINER_PAGE_SIZE = 'containerPageSize',

  USER_PREFERRED_AUDIO_CODEC = 'userPeferredAudioCodecs',
  ENABLE_CONTINUE_WATCHING = 'enableContinueWatching',
  PERSONALISED_CONTAINERS_INDEX = 'personalisedContainersIndex',
  BECAUSE_YOU_WATCHED_LIMIT = 'bywLimit',
  PERSONALISED_NAME = 'personalisedName',
  VIDEO_4K_TAG = 'video_4k_tag',
  AUDIO_DOLBY51_TAG = 'audio_dolby51_tag_v2',
  AUDIO_DOLBYATMOS_TAG = 'audio_dolbyatmos_tag',
  AUDIO_51_TAG = 'audio_51_tag_v2',
  ACTIVATION_CODE_INTERVAL = 'activationCodeInterval',
  ENABLE_CHECK_REDEEM = 'enableCheckRedeem',
  CONTINUE_WATCHING_PAGE_SIZE = 'continueWatchingPageSize',
  FAVORITE_PAGE_SIZE = 'favoritePageSize',
  TV9_CHANNEL_ID = 'tv9ChannelId',
  TV9_IFRAME_URL = 'tv9IframeUrl',
  THROTTLE_API_KEY = 'throttleApiUrl',

  // Newly added keys
  ENABLE_KEYFRAME = 'enableKeyframe',
  ADD_PREFERRED_BITRATE = 'addPreferredBitrate',
  ENABLE_ADS = 'enableAds',
  LOAD_PLAYER_AD_MARKS = 'loadPlayerAdMarks',
  SEGMENT_PREFETCH_LIMIT = 'segmentPrefetchLimit',
  ENABLE_PRELOADING = 'enablePreloading',
  ENABLE_UI_ELEMENTS = 'enableUiElements',
  USE_STYLED_LINEAR_ADS = 'useStyledLinearAds',
  CONTENT_PLAYBACK_DELAYMS = 'contentPlaybackDelayMs', // midroll updates
  ADTOCONTENT_TRANSITION_FACTOR = 'adToContentTransitionFactor', // midroll updates
  ADCUETRANSITION_DELAYMS = 'adCueTransitionDelayMs', //  midroll updates
  LICENSE_REFRESH_KEY = 'licenseRefreshURL',
  AD_BLACKLIST_MODELS = 'adBlacklistModels',
  CONTENT_TO_AD_TRANSITION_DELAY = 'contentToAdTransitionDelay',
  LOAD_VIDEO_TIME_OUT = 'loadVideoTimeout',
  MIME_TYPES = 'mimeTypes',

  SMARTTV_V2_LOCALIZATION_URL = 'smarttvV2LocalizationURL',
  SMARTTV_V2_ERROR_CODE_TRANSLATION = 'smarttvV2ErrorCodeTranslation',

  ENABLE_KEYFRAME_V2 = 'enableKeyframeV2',
  KEYFRAME_BLACKLIST_MODELSV2 = 'keyframeBlacklistModelsV2',
  SEARCH_DEBOUNCE_DELAY = 'searchDebounceDelay',
  TELUGU_PREF_LANG_ACTOR_IMAGE = 'teluguPrefLangActorImage',
  TAMIL_PREF_LANG_ACTOR_IMAGE = 'tamilPrefLangActorImage',
  DISCOUNTED_REGIONS = 'discountedRegions',
  ONBOARDING_IMAGE_URL = 'onboardingImageUrl',
}

export type AppConfig = {
  [key in AppConfigKeys]: string;
};

export type AppConfigList = {
  key: string;
  value: string;
  type: string;
};
